/** Bump when replacing homepage files at the same path.
 *  5: ring-pro / ring-air banner videos moved to /web_v2/home-v4/ring-pro-air/. */
const HOME_ASSET_VERSION = '5';

export function homeAssetSrc(src: string): string {
  const join = src.includes('?') ? '&' : '?';
  return `${src}${join}v=${HOME_ASSET_VERSION}`;
}
